import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { CartState } from './state';

const initialCatState: CartState = {
  cart: null,
  editCartItem: null
}

const cartReducers = createReducer(
  initialCatState,
  on(actions.EditReservation, (state, { cartItem }) => ({ ...state, editCartItem: cartItem })),
  on(actions.LoadCartSuccess, (state, { cart }) => ({ ...state, cart })),
  on(actions.LoadOrderSuccess, (state, { order }) => ({ ...state, order })),
  on(actions.LoadCheckoutFieldsSuccess, (state, { checkoutFields }) => ({ ...state, checkoutFields })),
)

export function reducers(state: CartState | undefined, action: Action) {
  return cartReducers(state, action)
}
